import {createFeatureSelector, createSelector} from '@ngrx/store';
import {stationsFeatureKey, StationsState} from './stations.reducer';
import {LibOptionValue} from 'daisy-design-system-front';
import {StationGnvList} from '../../../swagger-gen/gnvert-secured/models/station-gnv-list';
import {StationGnv} from '../../../swagger-gen/gnvert-secured/models/station-gnv';

const selectStationsState = createFeatureSelector<StationsState>(stationsFeatureKey);

export const selectStationsForm = createSelector(
  selectStationsState,
  state => state
);

export const selectStationsList = createSelector(
  selectStationsState,
  state => state?.stations || []
);

export const selectStationOptions = (showAllStations: boolean) => createSelector(
  selectStationsState,
  state => {
    const collection = showAllStations
      ? state?.stations
      : (state?.stations ?? []).filter(s => s.service === "IN_USE" || s.service === "IN_USE_WITH_RESTRICTIONS")

    return convertToOptions(collection || []);
  }
);

export const selectStationsByUids = (stationUids: string[]) => createSelector(
  selectStationsState,
  state => (state?.stations ?? [])?.filter(station => stationUids.includes(station.uid)) || []
);

export const selectStationOptionsByUids = (stationUids: string[]) => createSelector(
  selectStationsState,
  state => {
    const stations = (state?.stations ?? [])?.filter(station => stationUids.includes(station.uid)) || []
    return convertToOptions(stations, )
  }
);

function convertToOptions(
  stations: StationGnvList,
): LibOptionValue<string>[] {
  return stations.map(convertToOption);
}

function convertToOption(station: StationGnv): LibOptionValue<string> {
  const code = station.code ? `- ${station.code}` : '';
  return { label: `${station.name} ${code}`, value: station.uid };
}
